<template>
  <div class="password-container">

    <div class="password-level">
      <div class="password-level-div">
        <span class="password-level-span" :class="span1Css">{{tip1}}</span>
        <span class="password-level-span" :class="span2Css">{{tip2}}</span>
        <span class="password-level-span" :class="span3Css">{{tip3}}</span>
      </div>

      <div class="password-level-desc">{{content}}</div>
    </div>

  </div>
</template>

<script>
export default {
  name: "password-strength",
  components: {
  },
  props: {
    password: {
      type: [String, Number],
      required: true,
      default: ''
    }
  },
  watch: {
    password: {
      immediate: true,
      handler: function(newVal){
        let level = this.checkpassword(newVal)
        console.log("密码等级",level);
        switch (level) {
          case 1:
            this.resetTip();
            this.span1Css = "password-level-span-low"
            this.tip1 = "弱"
            this.content = "密码过于简单，建议设置8位以上大小写字母+特殊符号+数字。"
            break;
          case 2:
            this.resetTip();
            this.span1Css = "password-level-span-mid"
            this.span2Css = "password-level-span-mid"
            this.tip2 = "中"
            this.content = "密码安全性较好。"
            break;
          case 3:
            this.resetTip();
            this.span1Css = "password-level-span-high"
            this.span2Css = "password-level-span-high"
            this.span3Css = "password-level-span-high"
            this.tip3 = "强"
            this.content = "密码安全性较好。"
            break;
          default :
            this.resetTip();
            this.span1Css = "password-level-span-high"
            this.span2Css = "password-level-span-high"
            this.span3Css = "password-level-span-high"
            this.tip3 = "强"
            this.content = "密码安全性较好。"
            break;
        }
      }

    }
  },
  data() {
    return {

      content: '密码过于简单，建议设置8位以上大小写字母+特殊符号+数字。',
      strength: 1,
      span1Css: "password-level-span-low",
      span2Css: "",
      span3Css: "",
      tip1: '弱',
      tip2: '',
      tip3: '',
    };
  },

  methods: {
    checkpassword(value) {
               let  pwdLevel=0;
                
                if (!value||value.length < 8) return 1;
                if (/\d/.test(value)) pwdLevel++;//数字
                if (/[a-z]/.test(value)) pwdLevel++; //小写
                if (/[A-Z]/.test(value)) pwdLevel++; //大写
                if (/.*[~!@#$%^&*()_\-+|<>,.?/:;'[\]{}"]+.*/.test(value)) pwdLevel++;//特殊字符
            
                return pwdLevel;

    },
    resetTip() {
      this.span1Css = ""
      this.span2Css = ""
      this.span3Css = ""
      this.tip1 = ''
      this.tip2 = ''
      this.tip3 = ''
    }
  }
}
</script>

<style lang="scss" >
.password-container {
  .password-level-div {
    display: inline-block;
  }
  .password-level-span {
    width: 40px;
    height: 16px;
    background: #dddddd;
    display: inline-block;
    vertical-align: top;
    text-align: center;
    line-height: 16px;
    color: #ffffff;
    margin-right: 1px;
  }
  .password-level-desc {
    color: #606366;
    display: inline;
    font-size: 12px;
    margin-left: 8px;
  }

  .password-level {
    background: #ffffff;
    border: 1px solid #c7c9cf;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
    display: inline-block;
    line-height: 20px;
    font-size: 12px;
    top: 0;
    text-align: left;
    padding: 8px;
    border-radius: 4px;
  }

  .password-level-span-low {
    background: #e03024 !important;
  }

  .password-level-span-mid {
    background: #f2b927 !important;
  }
  .password-level-span-high {
    background: #21cc71 !important;
  }
}
</style>